// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","945":"mainlayout"}[chunkId] + "." + {"535":"6cb9d15a","945":"ffb35285"}[chunkId] + ".css";
};